export default __webpack_public_path__ + "static/media/contractor.a3fb5093.png";